import {defineStore} from "pinia";
import {useAuthStore} from "@/stores/authStores";
import {useICPStore} from "@/stores/icpStore";
import {useGroupCallsStore} from "@/stores/groupCallsStore";
import {useMediaStore} from "@/stores/mediaStore";
import api from '@/services/api'
import {useContactsStore} from "@/stores/contactsStore";

export const useCallsStore = defineStore(
    'calls',
    {
        state: () => ({
            calls: [],
            selectedCall: [],
            callHistory: [] // Fetch from the BE
        }),

        getters: {

            incomingCalls: state => {
                return state.calls.filter(call => call.status === 'Ringing' && call.direction === "Incoming")
                    .sort((a, b) => {
                        if (a.type === 'Emergency' && b.type !== 'Emergency') return -1;
                        if (a.type !== 'Emergency' && b.type === 'Emergency') return 1;
                        return b.time - a.time; //TODO: fix this
                    });
            },

            activeCalls: state => {
                return state.calls.filter(call => (call.status === 'Ringing' && call.direction === "Outgoing") || (call.status === "Transmitting") || (call.status === "Calling") || (call.status === "Holding"))
                    .sort((a, b) => {
                        if (a.type === 'Emergency' && b.type !== 'Emergency') return -1;
                        if (a.type !== 'Emergency' && b.type === 'Emergency') return 1;
                        return b.time - a.time;
                    });
            }

        },

        actions: {
            setCallVolume(newVolume){
                this.selectedCall[0].volume = newVolume;
                useICPStore().ICP.dispatch.device.setVolume({
                    "cid": this.selectedCall[0].cid,
                    "volume": newVolume.toString(),
                    "callback": (data) => {console.log(data)}
                })
            },

            setSelectedCall(item) {
                if (item) {
                    useGroupCallsStore().setSelectedCall([]);
                    this.selectedCall = [item]
                } else {
                    this.selectedCall = [];
                }
                useMediaStore().alignShowValue();
                if (this.activeCalls.length > 0) {
                    this.activeCalls.forEach(call => {
                        if (!item || call.cid !== item.cid) {
                            useICPStore().ICP.dispatch.voice.hold({
                                "cid": call.cid,
                                "callback": (data) => {
                                    if (data.rsp === '0') {
                                        //call.status = 'Holding';
                                        console.log("Call is on hold: ", call.cid);
                                    }
                                }
                            })
                        } else {
                            useICPStore().ICP.dispatch.voice.unhold({
                                "cid": call.cid,
                                "callback": (data) => {
                                    if (data.rsp === '0') {
                                        //call.status = 'Transmitting';
                                        console.log("Call is unheld: ", call.cid);
                                    }
                                }
                            })
                        }
                    });
                }
            },

            receiveCall(data) {
                const newCall = {
                    cid: data.value.cid,
                    caller: data.value.caller,
                    callee: data.value.callee,
                    trainNum: "Unknown (" + data.value.caller + ")",
                    runAndDriveNum: "TODO",
                    zoneId: "Unknown",
                    direction: "Incoming",
                    status: "Ringing",
                    volume: useMediaStore().defaultValue,
                    time: Date.now(),
                    type: "Normal"
                }
                this.calls.push(newCall);
                this.fetchIncomingCall(data.value.caller, data.value.cid);
            },

            startNewCall(data) {
                const newCall = {
                    cid: data.value.cid,
                    caller: useAuthStore().loggedUser,
                    callee: data.value.callee,
                    trainNum: "Unknown (" + data.value.callee + ")",
                    runAndDriveNum: "TODO",
                    zoneId: "Unknown",
                    direction: "Outgoing",
                    status: "Calling",
                    volume: useMediaStore().defaultValue,
                    time: Date.now(),
                    type: "Normal"
                };

                this.calls.push(newCall);
                this.setSelectedCall(newCall);
                this.fetchIncomingCall(data.value.callee, data.value.cid);
            },

            answerCall(data) {
                var index = 0;
                index = this.calls.findIndex(c => c.cid === data.value.cid);
                if (index !== -1) {
                    this.calls[index].status = 'Transmitting';
                    this.calls[index].volume = useMediaStore().defaultValue;
                    this.setSelectedCall(this.calls[index]);
                    useICPStore().ICP.dispatch.device.setVolume({
                        "cid": data.value.cid,  // default volume
                        "volume": useMediaStore().defaultValue.toString(),
                        "callback": (data) => {
                            console.log(data)
                        }
                    })
                    // call SDK to do its work
                }
            },

            rejectCall(selected) {
                const index = this.calls.findIndex(c => c === selected);
                if (index !== -1) {
                    //remove time and add start time endtime
                    this.calls[index].startTime = this.calls[index].time;
                    this.calls[index].endTime = Date.now();
                    // remove field time
                    delete this.calls[index].time;

                    this.calls[index].status = 'Rejected';

                    // remove from calls and put in call history
                    //this.callHistory.push(this.calls[index]);

                    this.pushToHistory(this.calls[index])
                    this.calls.splice(index, 1);

                    //this.selectedCall = []; // Clear selected call after ending
                }
            },


            updateCallStatus(data, status) {
                const index = this.calls.findIndex(c => c.cid === data.value.cid);
                if (index !== -1) {
                    this.calls[index].status = status;
                    // Update other fields if necessary
                }
            },

            releaseCall(data) {
                const index = this.calls.findIndex(c => c.cid === data.value.cid);
                if (index !== -1) {
                    this.calls[index].startTime = this.calls[index].time;
                    this.calls[index].endTime = Date.now();
                    const currStatus = this.calls[index].status // Assuming data.value.status contains the new status
                    if (currStatus === 'Transmitting') {
                        this.calls[index].status = 'Ended';
                    } else if (currStatus === 'Ringing' || currStatus === 'Calling') {
                        this.calls[index].status = 'Missed';
                    }
                    // Update other fields if necessary
                    //this.callHistory.push(this.calls[index]);
                    this.pushToHistory(this.calls[index]);

                    this.calls.splice(index, 1);

                    //this.selectedCall = []; // Clear selected call after ending
                }
            },

            pushToHistory(call) {
                // if active calls is not empty, set selected call to the first active call
                if (this.activeCalls.length > 0) {
                    this.setSelectedCall(this.activeCalls[0]);
                } else {
                    this.selectedCall = [];
                }
                useMediaStore().alignShowValue();
                api.post(
                    '/individualCall/addToHistory',
                    call,
                    {headers: {'Content-Type': 'application/json'}}
                )
                    .then(response => {
                        console.log(response);
                        this.fetchHistory();
                    })
                    .catch(error => {
                        console.error("There was an error adding the call to history:", error);
                    });
            },

            fetchHistory() {
                api.get('/individualCall/getHistory', {
                    params: {
                        user: useAuthStore().loggedUser
                    }
                })
                    .then(response => {
                        this.callHistory = response.data;
                    })
                    .catch(error => {
                        console.error("There was an error fetching the call history:", error);
                    });
            },

            fetchIncomingCall(caller, cid) {
                // first check if the caller one of the handheld isdns
                const contactsStore = useContactsStore();
                const hhIndex = contactsStore.handheld.findIndex(hh => hh.isdn === caller);
                const callIndex = this.calls.findIndex(c => c.cid === cid);
                if (hhIndex !== -1) {
                    this.calls[callIndex].trainNum = contactsStore.handheld[hhIndex].radioId;
                    this.calls[callIndex].zoneId = "-";

                }else{
                    api.get('/train/getTrainDetailByIsdn', {
                        params: {
                            user: caller
                        }
                    })
                        .then(response => {
                            if (response.data !== "") {
                                this.calls[callIndex].trainNum =  response.data.trainId
                                this.calls[callIndex].zoneId = response.data.location
                            }
                        })
                        .catch(error => {
                            console.error("There was an error fetching data of the caller:", error);
                        });
                }

            },

            resetTrainInfo() {
                this.incomingCallTrainInfo = {
                    isdn: '',
                    name: null,
                    driverNumber: null,
                    position: null,
                };
            }
        }
    }
)